import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberAccount } from '../../../../../models/transactions/member-account';

@Component({
  selector: 'app-ip-affected-accounts-card',
  templateUrl: './ip-affected-accounts-card.component.html',
  styleUrls: ['./ip-affected-accounts-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IPAffectedAccountsCardComponent {
  @Input() memberId!: number;
  @Input() memberName: string = '';
  @Input() accounts: MemberAccount[] = [];
  @Input() isLoading: boolean = false;
}
